import '@formatjs/intl-pluralrules/polyfill-locales';
import ComponentProvider from '@empiriecom/module-components/ComponentProvider';
import { History } from 'history';
import React, { FunctionComponent } from 'react';
import { hot } from 'react-hot-loader';
import { Route, Switch } from 'react-router-dom';
import doOpenSearchbar from '@empiriecom/module-inspire-components/utils/openSearchbar';
import config from '@/config';
import LocaleSwitcher from '@empiriecom/module-components/LocaleSwitcher';
import { getTenantSpecificLocales } from '@empiriecom/module-inspire-components/utils/userPreferredLocale';
import ConfigProvider from '@empiriecom/module-inspire-components/components/ConfigProvider';
import ModuleConfigProvider from '@empiriecom/module-components/ConfigProvider';
import { Locale } from '@empiriecom/module-components/IntlProvider';
import PageContainer from '../PageContainer';
import messages from '../../../locales/default/index';
import ReloadLink from '../ReloadLink';

/* Don't use destructuring! inlining doesn't work with destructured process.env variables */
// eslint-disable-next-line prefer-destructuring
const App: FunctionComponent<{ serverLocale?: Locale; disableLegacy?: boolean }> = ({
  serverLocale,
  disableLegacy,
}): JSX.Element => {
  const fallbackLocale = config?.apiParams?.values?.apiDefaultParams?.locale || 'de-CH';
  const locales = getTenantSpecificLocales(
    config?.apiParams?.values?.apiDefaultParams?.localesToSwitch,
  );

  // mgruben - workaround for OGES-380 - opening searchbar on mobile-view
  doOpenSearchbar();

  return (
    <ConfigProvider config={config}>
      <ModuleConfigProvider config={config}>
        <ComponentProvider
          data-testid="app-component-provider"
          messages={messages}
          fallbackLocale={fallbackLocale}
          locale={serverLocale}
        >
          <Switch>
            <Route
              path={config.routingPaths.exact}
              exact
              render={({
                history,
              }: {
                /* eslint-disable-next-line react/no-unused-prop-types */
                history: History;
              }): JSX.Element => <PageContainer history={history} disableLegacy={disableLegacy} />}
            />
            <Route
              path={config.routingPaths.prefix}
              render={({
                history,
              }: {
                /* eslint-disable-next-line react/no-unused-prop-types */
                history: History;
              }): JSX.Element => <PageContainer history={history} disableLegacy={disableLegacy} />}
            />
            {/* Route for potential links rendered with router Link component the should be redirected */}
            <Route path="*" component={ReloadLink} />
          </Switch>
          <LocaleSwitcher localesToSwitch={locales} fallbackLocale={fallbackLocale} />
        </ComponentProvider>
      </ModuleConfigProvider>
    </ConfigProvider>
  );
};

export default hot(module)(App);
